import { createStyleSheet } from '@shared-ui/theme'
import { rh } from '@shared-ui/theme/scale'
import { Dimensions } from 'react-native'

export const useCreateStyles = createStyleSheet(() => ({
  statusBarStyle: {
    height: '100%',
    width: Dimensions.get('window').width,
  },
  statusBarWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: rh(80),
    zIndex: 10,
    pointerEvents: 'none',
  },
}))
